import swal from "sweetalert";
import { toast } from "react-toastify";

import React, { useState } from "react";
import commoncss from "./../../css/common.module.css";
import buttoncss from "./../../css/button.module.css";
import Modal from "./../../elements/Modal";
import { Button } from "./../../elements/Button";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import InputGroup from "./../../elements/InputGroup";
import { createTBpushPackage } from "../../../Bookclosure/Services/ApiHandler";

const CreatePackageModal = ({
  setCreatePackageModal,
  companyId,
  handleDisableSelected,
  workspaceId,
  selectedEntries,
}) => {
  const [packageName, setPackageName] = useState(null);

  const createPushPackage = () => {

    const payload = {
      companyID: companyId,
      workspaceID: workspaceId,
      projectID: "67fcce5e9dd0e4369c87e385",
      userID: "67bc5517f416b56bd8ddeb87",
      packageData: selectedEntries,
      packageName: packageName,
    };
    createTBpushPackage(payload)
      .then((response) => {
        toast.success("Push Package created Successfully");

        setCreatePackageModal(false);
        handleDisableSelected();
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Create COA failed",
          "error"
        );
      });
  };
  return (
    <Modal
      title="Package Name"
      bodycss={commoncss.unsetPadding}
      headerActions={
        <CloseIcon
          onClick={() => {
            setCreatePackageModal(false);
          }}
          className="clickable"
        />
      }
      onClose={() => console.log("Modal Closed")}
      footerActions={
        <>
          <Button
            btnColor={buttoncss.secondary}
            onClick={() => {
              setCreatePackageModal(false);
            }}
            label="Cancel"
          />
          <Button
            btnColor={buttoncss.primary}
            label="Save"
            onClick={() => {
              createPushPackage();
            }}
          />
        </>
      }
    >
      <div className={commoncss.pd1530}>
        <InputGroup
          label="Package Name"
          inputs={[
            <>
              <input
                type="text"
                onChange={(value) => {
                  setPackageName(value.target.value);
                }}
              />
            </>,
          ]}
        />
        <span className={commoncss.guidingLabel}>
          Lorem ipsum dolor sit amet consectetur. Vitae lectus dignissim mauris orci.
        </span>
      </div>
    </Modal>
  );
};

export default CreatePackageModal;
